import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUpAndDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.616 6.926A1 1 0 0 0 10 7a1 1 0 0 0 .71-1.71l-3-3a1 1 0 0 0-1.42 0l-3 3a1.004 1.004 0 0 0 1.42 1.42L6 5.414V21a1 1 0 1 0 2 0V5.414L9.29 6.71a1 1 0 0 0 .326.216M18 18.586V3a1 1 0 0 0-2 0v15.586l-1.29-1.296a1.004 1.004 0 1 0-1.42 1.42l3 3A1 1 0 0 0 17 22a1 1 0 0 0 .71-.29l3-3a1.004 1.004 0 0 0-1.42-1.42z"
    />
  </svg>
);
export default SvgArrowUpAndDown;
